import Add20 from '@carbon/icons-react/es/add/20';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ReactComponent as NoMemberFieldsSVG } from 'assets/svgs/empty-states/no-member-fields.svg';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';
import { RoutePaths } from 'constant';

const StyledLink = styled(Link)`
  color: white;
`;

export const TeamMemberFieldsEmptyState: FC<{
  showCreateSection: () => void;
}> = ({ showCreateSection }) => (
  <EmptyStateContainer $transparent>
    <EmptyState
      image={<NoMemberFieldsSVG />}
      message={<FormattedMessage id="settings.team_members.create.fields" />}
      primaryCTA={
        <StyledLink to={RoutePaths.newTeamMemberField}>
          <EmptyState.CallToAction.Primary icon={<Add20 />}>
            <FormattedMessage id="settings.fields.new" />
          </EmptyState.CallToAction.Primary>
        </StyledLink>
      }
      secondaryCTA={
        <EmptyState.CallToAction.Secondary
          onClick={() => {
            showCreateSection();
          }}
        >
          <FormattedMessage id="settings.fields.section.new" />
        </EmptyState.CallToAction.Secondary>
      }
    />
  </EmptyStateContainer>
);
